import { Navigate, useLocation, useNavigate } from "react-router";
import { LandingPage } from "../components/LandingPage";
import { useTownAccess } from "../contexts/TownAccessContext";

export function LandingRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const access = useTownAccess();
  if (new URLSearchParams(location.search).has("invite")) {
    return <Navigate replace to={`/join${location.search}`} />;
  }
  // Back to the office opened last; Settings has the way to another office.
  if (access) return <Navigate replace to="/town" />;
  return <LandingPage onEnter={() => navigate("/join")} />;
}
